export class Semaphore {
  #locked = 0;
  #waitList: Array<() => void> = [];

  public constructor(public maxLocks: number) {}

  public unlock() {
    if (this.#locked <= 0) {
      throw new Error('no locked semaphore');
    }
    this.#locked--;
    if (this.#waitList.length > 0) {
      const nextResolve = this.#waitList.shift();
      this.#locked++;
      nextResolve?.();
    }
  }

  public lock() {
    return new Promise<void>((resolve) => {
      if (this.#locked >= this.maxLocks) {
        this.#waitList.push(resolve);
      } else {
        this.#locked++;
        resolve();
      }
    });
  }

  public isLocked() {
    return this.#locked >= this.maxLocks;
  }

  public getLockCount() {
    return this.#locked;
  }

  public getWaitCount() {
    return this.#waitList.length;
  }

  public async runExclusive<T>(fn: () => T): Promise<T> {
    try {
      await this.lock();
      return await fn();
    } finally {
      this.unlock();
    }
  }
}
